import {
  FcAdvance,
  FcBusinessman,
  FcCustomerSupport,
  FcSurvey,
} from "react-icons/fc";

import "./Service.css";

import React from "react";

const Service = () => {
  return (
    <div id="fetures">
      <div className="row mt-4 custom-service mx-auto">
        <div class="card-group  ">
          <div className="col-lg-4 col-sm-6 col-12">
            <div class="card ">
              <div>
                <h1>
                  <FcBusinessman />
                </h1>

                <h3 class="card-title">Doctors Timetable</h3>
                <p class="card-text">
                  This card has supporting text below as a natural lead-in to
                  additional content.
                </p>
                <h5>
                  View Timetable <FcAdvance />{" "}
                </h5>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-sm-6 col-12">
            <div class="card ">
              <div>
                <h1>
                  <FcCustomerSupport />
                </h1>

                <h3 class="card-title">Emergency Call</h3>
                <p class="card-text">
                  This card has supporting text below as a natural lead-in to
                  additional content.
                </p>
                <button className="btn btn-danger"> +601121861459</button>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-sm-6 col-12">
            <div class="card ">
              <div>
                <h1>
                  <FcSurvey />
                </h1>

                <h3 class="card-title">Appointment</h3>
                <p class="card-text">
                  This card has supporting text below as a natural lead-in to
                  additional content.
                </p>
                <h5>
                  Get Started <FcAdvance />{" "}
                </h5>
              </div>
            </div>
          </div>
        </div>

        {/* <Row xs={1} md={2}  className="g-5 mt-3">
        {Array.from({ length: 3 }).map((_, idx) => (
          <Col>
            <Card>
              <Card.Img variant="top" src="holder.js/100px160" />
              <Card.Body>
                <Card.Title>Card title</Card.Title>
                <Card.Text>
                  This is a longer card with supporting text below as a natural
                  lead-in to additional content. This content is a little bit
                  longer.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row> */}
      </div>
    </div>
  );
};

export default Service;
